import { useContext, useEffect } from 'react';
import L from 'leaflet';
import { MapContext } from './map-ctx';
import { Wgs84Coordinates } from '../../models';

interface PathProps {
  id?: string;
  points: Wgs84Coordinates[];
  options?: L.PolylineOptions;
}

export function Path({ id, points, options }: PathProps) {
  const { map } = useContext(MapContext);

  useEffect(() => {
    const mapRef = map.current?.ref; // L.Map instance
    if (!mapRef || !points || points.length < 2) {
      return;
    }

    const validPoints = points.filter(
      (p) => p && typeof p.lat === 'number' && typeof p.lon === 'number'
    );

    if (validPoints.length < 2) {
      return;
    }

    const latLngs = validPoints.map((p) => L.latLng(p.lat ?? 0, p.lon ?? 0));

    const polyline = L.polyline(latLngs, options);

    if (id) {
      (polyline as any).customId = id;
    }

    polyline.addTo(mapRef);

    return () => {
      if (mapRef && mapRef.hasLayer(polyline)) {
        polyline.remove();
      }
    };
  }, [map, points, options, id]);

  return null;
}
